import { createSelector } from 'reselect';
import { filterContracts } from '../../PowertrainOverview/helper';
import { getSelectedNotification } from '../../PowertrainOverview/Header/NotificationDropdown/selectors';
import { createErrorDataSelector } from 'selectors/selectorUtils';

const getLoadingStatusAsset = ({ powertrainTools }) => {
    return powertrainTools?.subscriptionStatus?.subscriptionArr?.loadingStatus;
};

const getActiveTab = ({ powertrainTools }) => {
    return powertrainTools.subscriptionStatus.activeTab;
};
const getSubscriptionData = ({ powertrainTools, generalFilter }) => {
    return filterContracts(powertrainTools?.subscriptionStatus?.subscriptionArr?.data?.assetSubscriptionsInfos, generalFilter?.assets?.data);
};

const getSelectedOrganizationId = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0]?.organizationID;
};

const getAssets = ({ overview }) => {
    return overview?.assets?.data;
};

const getSubscriptionError = ({ powertrainTools }) => {
    return {
        loadingStatus: powertrainTools?.subscriptionStatus?.subscriptionArr?.loadingStatus,
        error: powertrainTools?.subscriptionStatus?.subscriptionArr?.error,
        errorCode: powertrainTools?.subscriptionStatus?.subscriptionArr?.error?.statusCode
    };
};

// Memoized selector for subscription status error data
const getSubscriptionErrorData = createErrorDataSelector(getSubscriptionError);


export const getModel = createSelector(
    [
        getLoadingStatusAsset,
        getActiveTab,
        getSubscriptionData,
        getSelectedNotification,
        getSelectedOrganizationId,
        getAssets,
        getSubscriptionErrorData
    ],
    (
        loadingStatusAsset,
        activeTab,
        contracts,
        selectedNotification,
        selectedOrganizationId,
        assets,
        subscriptionErrorData
    ) => {
        return {
            loadingStatusAsset,
            activeTab,
            contracts,
            selectedNotification,
            selectedOrganizationId,
            assets,
            subscriptionErrorData
        };
    }
);
